
import type {ManifestationExportProps, ManifestationV4} from '../types';

export const getManifestationExportProps = (
  manifestation: ManifestationV4,
): ManifestationExportProps => {
  return {
    productForm: manifestation?.productForm,
  };
};
